import { Outlet, Link, useLocation } from "react-router-dom";

export default function Layout() {
  const location = useLocation();
  const isPlanPage = location.pathname.startsWith("/p/");

  return (
    <div className={`flex flex-col bg-base-200 w-full max-w-full overflow-x-hidden ${isPlanPage ? 'h-screen overflow-hidden' : 'min-h-screen'}`}>
      {/* Header - only shown on non-plan pages */}
      {!isPlanPage && (
        <header className="flex items-center justify-between px-4 py-2 bg-base-100 border-b border-base-300">
          <div className="flex items-center gap-3">
            <Link to="/" className="text-lg font-bold">
              hence
            </Link>
            <a
              href="https://docs.hence.run"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-base-content/60 hover:text-primary transition-colors"
            >
              Docs
            </a>
          </div>
        </header>
      )}

      <main className={`flex-1 flex flex-col min-h-0 w-full max-w-full ${isPlanPage ? 'overflow-hidden' : 'overflow-x-hidden overflow-y-auto'}`}>
        <Outlet />
      </main>

      {/* Footer - only shown on non-plan pages */}
      {!isPlanPage && (
        <footer className="flex items-center justify-center px-4 py-3 bg-base-100 border-t border-base-300 text-sm text-base-content/60">
          Made by{" "}
          <a
            href="https://anuna.io"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-1 hover:text-primary transition-colors"
          >
            Anuna Research
          </a>
        </footer>
      )}
    </div>
  );
}
